export default {
  LIST_FETCHED: 'ENTITIES_FETCHED',
  LIST_LOAD: 'ENTITIES_LOAD',
  ITEM_DETAIL: 'ENTITIES_DETAIL',
  BUTTON_LOAD: 'ENTITIES_BUTTON_LOAD',
};
